import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
  OnChanges,
  OnDestroy,
  ChangeDetectorRef
} from "@angular/core";
import * as moment from "moment";
import { MessageService } from './../../../services/message-service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'mobile-date-range',
  templateUrl: './mobile-date-range.component.html',
  styleUrls: ['./mobile-date-range.component.scss']
})
export class MobileDateRangeComponent implements OnInit, OnChanges, OnDestroy {

  @Input() filterInfo = {};
  @Output() dataSelected: EventEmitter<any> = new EventEmitter();
  @Input() maxDate = 1;
  @Input() noDateLimit = true;
  showPicker = false;
  private unsubscribe: Subject<void> = new Subject();
  setMax = moment().subtract(this.maxDate, "days");
  getday = moment()
    .subtract(1, "days")
    .date();
  selected;
  defaultValueField;
  constructor(private message: MessageService, private cd: ChangeDetectorRef,
    ) {
  }

  ngOnInit() {
    this.initializeDateFilter();
    this.message.getMessage().pipe(takeUntil(this.unsubscribe)).subscribe(message => {
      if (message && message.filterReset) {
        this.selected = this.defaultValueField;
      }
    });
  }

  initializeDateFilter() {
    const selected = {
      startDate: moment().subtract(this.getday, "days"),
      endDate: moment().subtract(this.maxDate, "days")
    };
    this.setMax = moment().subtract(this.maxDate, "days");
    const today = new Date();
    if (today.getDate() < 6) {
      selected.startDate.subtract(1, "months");
    }
    this.defaultValueField = selected;


    if (this.filterInfo['value']) {
      
      const startDate = this.filterInfo['value']['startDate']?  moment(this.filterInfo['value']['startDate']) : "";
      const endDate = this.filterInfo['value']['endDate'] ? moment(this.filterInfo['value']['endDate']): "";
      this.selected = { startDate, endDate };
    } else {
      this.selected = JSON.parse(JSON.stringify(selected));
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.filterInfo) {
      this.initializeDateFilter();
    }
    this.cd.detectChanges();


  }

  choosedDateTime(e) {
    this.selected = e;
    this.toggleDateRangePicker();
    this.dateRangeSelected(e);

  }

  dateRangeSelected($event) {
    if ($event.startDate && $event.endDate) {
      const startDate = `${moment($event.startDate).format("YYYY-MM-DD")} 00:00:00`;
      const endDate = `${moment($event.endDate).format("YYYY-MM-DD")} 23:59:59`;
      this.filterInfo['value'] = { startDate, endDate };
      this.dataSelected.emit(this.filterInfo);
    } else {
      this.filterInfo['value'] = { startDate: "", endDate: "" };
      this.dataSelected.emit(this.filterInfo);
    }
  }

  toggleDateRangePicker() {
    this.showPicker = !this.showPicker;
  }

  ngOnDestroy() {
    this.filterInfo = null;
    this.selected = null;
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
